import React from "react";
import { useNavigate } from "react-router-dom";
import { LuArrowLeft, LuShieldCheck, LuSparkles, LuStar } from "react-icons/lu";
import premiumBanner from "../assets/zuno/zuno_premium_conforto_em_movimento.png";

export default function PassengerPremium() {
  const navigate = useNavigate();

  return (
    <main className="zuno-app-shell premium-campaign-screen">
      <header className="premium-campaign-header">
        <button type="button" onClick={() => navigate(-1)} aria-label="Voltar"><LuArrowLeft /></button>
        <span>Zuno Premium</span>
      </header>

      <section className="premium-campaign-hero premium-campaign-hero--art">
        <img src={premiumBanner} alt="Zuno Premium: mais conforto, mais segurança, mais você" />
      </section>

      <section className="premium-campaign-benefits" aria-labelledby="premium-benefits-title">
        <p className="premium-campaign-kicker">Uma nova experiência de mobilidade</p>
        <h2 id="premium-benefits-title">Sua viagem em outro nível</h2>
        <div>
          <article><LuStar /><span><strong>Mais conforto</strong><small>Veículos selecionados para uma experiência superior.</small></span></article>
          <article><LuShieldCheck /><span><strong>Mais segurança</strong><small>O cuidado Zuno presente em cada etapa da viagem.</small></span></article>
          <article><LuSparkles /><span><strong>Atendimento premium</strong><small>Uma categoria pensada para seus melhores momentos.</small></span></article>
        </div>
        <button className="premium-campaign-back" type="button" onClick={() => navigate("/passenger-home")}>Voltar para a Home</button>
      </section>
    </main>
  );
}
